export default __webpack_public_path__ + "static/media/ff.616d45b6.png";